import withModal from '../../../../../../components/global/modal/withModal';
import AccountCardCheckoutPayment from './AccountCardCheckoutPayment';

export const ACCOUNT_CARD_CHECKOUT_PAYMENT_MODAL =
  'ACCOUNT_CARD_CHECKOUT_PAYMENT_MODAL';

export default withModal(AccountCardCheckoutPayment, {
  name: ACCOUNT_CARD_CHECKOUT_PAYMENT_MODAL,
  dismissible: false,
  size: 'xs',
  hideHeader: true,
  shouldCloseOnOverlayClick: false,
  className: 'modal-contained',
});
